import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./CustomMessageCarousel.css";
import { format, isToday, isYesterday } from "date-fns";
import { HiUserCircle, HiOutlineUser } from "react-icons/hi";

const formatDateLabel = (timestamp) => {
  const date = new Date(timestamp);
  if (isToday(date)) return "Today";
  if (isYesterday(date)) return "Yesterday";
  return format(date, "MMM dd, yyyy");
};

export function CustomMessageCarousel({ messages }) {
  if (!messages || !Array.isArray(messages) || messages?.length === 0)
    return (
      <div className="w-full max-w-full">
        <Swiper
          spaceBetween={12}
          slidesPerView={1}
          navigation
          modules={[Navigation]}
          className="message-carousel"
        >
          <SwiperSlide key={`no-msg`}>
            <div
              className={`h-[140px] overflow-y-auto px-3 py-2 rounded-md shadow-sm flex flex-col justify-center items-center bg-gray-100`}
            >
              {/* Message Body */}
              <div className="scrollable-message text-sm break-words overflow-y-auto max-h-[60px] pr-1">
                <span className="italic text-gray-400">No messages yet</span>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    );

  const slides = messages.slice(0, 10); // Optional limit

  return (
    <div className="w-full max-w-full">
      <Swiper
        spaceBetween={12}
        slidesPerView={1}
        navigation
        modules={[Navigation]}
        className="message-carousel"
      >
        {slides.map((msg, i) => {
          const dateLabel = formatDateLabel(msg.timestamp);
          return (
            <SwiperSlide key={`msg-${i}`}>
              <div
                className={`h-[140px] overflow-y-auto px-3 py-2 rounded-md shadow-sm flex flex-col justify-between
                  ${msg.is_from_me
                    ? "bg-blue-50 text-blue-800"
                    : "bg-gray-100 text-gray-800"
                  }
                `}
              >
                {/* Date Label */}
                <div className="text-xs text-gray-500 font-medium mb-1 text-center">
                  {dateLabel}
                </div>

                {/* Sender Info */}
                <div className="flex items-center justify-between text-xs font-semibold mb-1">
                  <span className="flex items-center gap-1">
                    {msg.is_from_me ? (
                      <>
                        <HiUserCircle className="text-blue-500" />
                        <span>You</span>
                      </>
                    ) : (
                      <>
                        <HiOutlineUser className="text-gray-500" />
                        <span>Client</span>
                      </>
                    )}
                  </span>
                </div>

                {/* Message Body */}
                <div className="scrollable-message text-sm break-words overflow-y-auto max-h-[60px] pr-1">
                  {msg.body || (
                    <span className="italic text-gray-400">No content</span>
                  )}
                </div>


                {/* Timestamp */}
                <div className="text-[11px] text-gray-500 mt-2">
                  {format(new Date(msg.timestamp), "p")}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
